import {UnityConfig} from './fingerprints/fingerprint';
import path from 'path';

export function getResourceData(files: string[], window: Window) {
  const allResources = window.performance.getEntriesByType('resource');
  const gameResources = allResources.filter((r) => files.some((f) => r.name.includes(f)));
  return gameResources.map((r) => ({
    // @ts-expect-error
    fromCache: r.transferSize === 0,
    duration: r.duration,
    // @ts-expect-error
    size: r.encodedBodySize,
    // @ts-expect-error
    transferSize: r.transferSize,
    startTime: r.startTime,
  }));
}

export function areResourcesCached(unityConfig: UnityConfig, window: Window) {
  const {dataUrl, frameworkUrl, codeUrl, gameId} = unityConfig;
  const urls = [
    path.join('unity-games', gameId, dataUrl),
    path.join('unity-games', gameId, frameworkUrl),
    path.join('unity-games', gameId, codeUrl),
  ];
  const resourceData = getResourceData(urls, window);
  return resourceData.every((r) => r.fromCache);
}
